package services.storage.http

import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import serialized.SerializedProject

/**
 * Response for
 */
@Serializable
sealed interface ArchiveProjectResponse : RestResponse<SerializedProject> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: SerializedProject) : ArchiveProjectResponse, RestResponse.GoodResponse<SerializedProject>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : ArchiveProjectResponse, RestResponse.BadResponse<SerializedProject>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: SerializedProject): ArchiveProjectResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): ArchiveProjectResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: SerializedProject?): ArchiveProjectResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}
